import { CardImage } from '../ui'

interface OtherProjectsSectionProps {
	className?: string
	style?: React.CSSProperties
	title?: string
	projectImage?: string
	projectTitle?: string
	projectLink?: string
}

export function OtherProjectsSection({
	className,
	style,
	title = 'Otros proyectos en los que participamos',
	projectImage = '/img/fondo-agua-card.avif',
	projectTitle = 'Fondo de Agua del Río Mendoza',
	projectLink,
}: OtherProjectsSectionProps) {
	const CardContent = (
		<CardImage
			backgroundImage={projectImage}
			title={projectTitle}
			showButton={false}
			iconButtonIcon="arrow-up-right-01-round"
			className="h-[365px] w-full md:w-[594px]"
		/>
	)

	return (
		<section className={className} style={style}>
			<div className="flex items-center justify-center py-16">
				<div className="flex w-full max-w-[1200px] flex-col items-center justify-between gap-6 px-[37.5px] md:flex-row md:items-center md:px-4">
					{/* Left Column - Title */}
					<div className="flex h-auto w-full flex-col items-center justify-center gap-6 md:h-[203px] md:w-[531px] md:items-start">
						<h2 className="font-parkinsans w-full text-center text-2xl leading-[45px] font-medium text-white md:text-left md:text-[32px]">
							{title}
						</h2>
					</div>

					{/* Right Column - Project Card */}
					{projectLink ? (
						<a href={projectLink} className="block">
							{CardContent}
						</a>
					) : (
						CardContent
					)}
				</div>
			</div>
		</section>
	)
}

export default OtherProjectsSection
